import React from 'react';

/**
 * AppShell — wraps every screen with the mobile phone-frame header.
 * Props:
 *  title       - header title
 *  onBack      - show back button and call this fn
 *  rightAction - {icon, onClick, label} — right-side header button
 *  rightAction2 - second right-side button
 *  noPadding   - skip content padding (for screens that control their own)
 *  bottomNav   - optional node rendered as a fixed bottom navigation bar
 *  contentRef  - optional ref attached to the scrollable content <main>, e.g. to save/restore scroll position
 */
const AppShell = ({ title, onBack, rightAction, rightAction2, children, noPadding, bottomNav, contentRef }) => {
  return (
    <div className="app-shell">
      <header className="app-header">
        {onBack && (
          <button className="app-header__back-btn" onClick={onBack} aria-label="Back">
            ←
          </button>
        )}
        <h1 className="app-header__title">{title}</h1>
        <div className="app-header__actions">
          {rightAction2 && (
            <button
              className="app-header__icon-btn"
              onClick={rightAction2.onClick}
              aria-label={rightAction2.label || 'Action'}
              title={rightAction2.label}
            >
              {rightAction2.icon}
            </button>
          )}
          {rightAction && (
            <button
              className="app-header__icon-btn"
              onClick={rightAction.onClick}
              aria-label={rightAction.label || 'Action'}
              title={rightAction.label}
            >
              {rightAction.icon}
            </button>
          )}
        </div>
      </header>
      <main ref={contentRef} className={`screen-content${noPadding ? '' : ''}`}>
        {children}
      </main>
      {bottomNav}
    </div>
  );
};

export default AppShell;
